<template>
  <div>
    <el-form-item :label="labelText(zdItem.label)" v-show="zdItem.display">
      <el-input
        v-model="zdFormattedValue"
        @change="inputChange"
        :placeholder="$t('view.placeholder')"
        style="width: 100%"
      >
        <template slot="append">
          <el-select
            v-model="selectedProcessType"
            @change="handleProcessTypeChange"
            :placeholder="$t('view.select_description')"
            style="width: 120px"
            :clearable="true"
          >
            <el-option
              v-for="item in restaurants"
              :key="item.value"
              :label="item.value"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </template>
      </el-input>
    </el-form-item>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
// import { apiServer } from "@/network/modules/detail-api";
// import { EventBus } from "@/views/NEW/module/spec/config/eventBus";
import base from "@/common/base.js";
import { ProductDescriptionUtils } from "@/common/productDescriptionUtils";
export default {
  name: "ZDAutoInputDescription", 
  props: {
    zdId: {
      type: String,
      required: true,
    },
  },
  inject: ["setItemCodeDataMethod","getCurrentDataMethod"],
  computed: {
    // 从 Vuex 获取当前组件的整个状态
    ...mapGetters("zdInput", {
      zdGetComponentState: "getComponentState",
    }),
    // 获取当前组件的状态对象
    zdComponentState() {
      return this.zdGetComponentState(this.zdId);
    },
    // 从状态对象中获取各个字段
    zdItem() {
      return this.zdComponentState;
    },
    labelText() {
      return (label) => {
        // console.info('this.zdItem:',this.zdItem)
        let key = "content." + label;
        key = key.toLowerCase().replaceAll(" ", "_");
        return this.$t(key);
      };
    },
    zdFormattedValue: {
      get() {
        let val = "";
       
        if (Array.isArray(this.zdItem.value)) {
          val = this.zdItem.value.join(",");
        } else {
          // 修复：添加null值检查，避免null.toString()错误
          val = this.zdItem.value != null ? this.zdItem.value.toString() : "";
        }
        return val; // 获取输入框的值
      },
      set(value) {
        this.zdUpdateComponent({
          id: this.zdId,
          field: "value",
          value: value,
        }); // 更新输入框的值
      },
    },
  },
  data() {
    return {
      restaurants: [],
      selectedProcessType: '',
    };
  },
  created() {
    // 获取当前数据
    const currentData = this.getCurrentDataMethod();
    // console.info('currentData:',currentData)
    
    // 使用 productDescriptionUtils 获取工艺类型选项
    // console.info('currentData.productType:',currentData.productType)
    let processTypes = ProductDescriptionUtils.getProcessTypes(currentData.productType);
    // console.info('processTypes:',processTypes)
    
    // 确保 processTypes 是数组
    if (!Array.isArray(processTypes)) {
      if (typeof processTypes === 'string') {
        // 如果是字符串，转换为数组
        processTypes = [processTypes];
      } else {
        // 如果既不是数组也不是字符串，使用空数组
        processTypes = [];
      }
    }
    
    // 将工艺类型转换为下拉选择框需要的格式
    this.restaurants = processTypes.map(processType => ({
      value: processType,
      description: ProductDescriptionUtils.getProductDescription(processType)
    }));
    
    // 下拉框默认为未选择状态
    this.selectedProcessType = '';
    
    this.zdFormattedValue = currentData.productDescription;
    // console.info('currentData.productDescription:',currentData.productDescription);
  },

  methods: {
    // 映射 Vuex 的动作
    ...mapActions("zdInput", ["updateComponent"]),
    zdUpdateComponent(payload) {
      this.updateComponent(payload); // 更新组件状态
    },
    getAuthShow(){
      return base.getAuthShow();
    },
    handleProcessTypeChange(value) {
      // 当用户选择工艺类型时，更新输入框的值
      const selectedItem = this.restaurants.find(item => item.value === value);
      if (selectedItem && selectedItem.description) {
        this.zdUpdateComponent({
          id: this.zdId,
          field: "value",
          value: selectedItem.description,
        });
      }
    },
    inputChange(value) {
      this.zdUpdateComponent({
        id: this.zdId,
        field: "value",
        value: value,
      });
    },
  },
};
</script>
